<template>
	<div class="spotify-player" v-if="src">
		<iframe
			:src="src"
			:height="height"
			class="player"
			width="100%"
			frameBorder="0"
			allowtransparency="true"
			allow="encrypted-media"
			@load="onLoad"
			:title="ariaLabel"
		></iframe>
	</div>
</template>

<script setup>
const isLoading = ref(true);

const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const height = computed(() => props.fields?.height?.value || "380");
const src = computed(() => props.fields?.src?.value || null);
const ariaLabel = computed(() => props.fields?.ariaLabel?.value || "Spotify Player");

function onLoad() {
	requestAnimationFrame(() => (isLoading.value = false));
}
</script>

<style lang="scss">
.spotify-player {
	padding: 0 var(--spacing-2, 16px) var(--spacing-2, 16px)
		var(--spacing-2, 16px);

	.player {
		margin-bottom: var(--spacing-2, 16px);
		display: block;
	}
}
</style>
